import { useQuery } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'

const { SECURE_BASE_URL } = config!

export type GetDCRequest = {
  vendorNumber: string
  store?: string
  addAllToOptions?: boolean
}

export type GetDCResponse = {
  data: {
    location_id: string
    location_long_name: string
  }[]
}

const getQueryParams = (props: GetDCRequest) => {
  const { vendorNumber, store } = props

  let queryParams = `vendornumber=${vendorNumber}`
  if (store) queryParams += `&store=${store}`

  return queryParams
}

const getDC = async (props: GetDCRequest): Promise<GetDCResponse> => {
  const { addAllToOptions } = props

  const { response: dcResponse } = await callAxios<{ response: GetDCResponse }>({
    url: `${SECURE_BASE_URL}/warehouse?${getQueryParams(props)}`,
    method: 'GET',
  })

  const sortedResponseData: GetDCResponse = {
    data: [...(dcResponse?.data ?? [])].sort((a, b) => parseInt(a.location_id) - parseInt(b.location_id)),
  }

  const responseWithAll: GetDCResponse = {
    data: [{ location_id: 'all', location_long_name: 'All DCs' }, ...sortedResponseData.data],
  }

  return addAllToOptions ? responseWithAll : sortedResponseData
}

export const useGetDC = (props: GetDCRequest) => {
  const { vendorNumber } = props

  const isEnabled = !!vendorNumber

  const {
    status: getDCStatus,
    isFetching: getIsDCLoading,
    data: dCData,
    error: getDCError,
  } = useQuery<GetDCResponse, CustomAxiosError>(['distributionCentre/get', vendorNumber], () => getDC(props), {
    enabled: isEnabled,
  })

  return {
    getDCStatus,
    getIsDCLoading,
    dCData,
    getDCError,
  }
}
